import { GQL } from 'src/graphql';
import { AdapterFunc } from 'src/hooks/useEntityAdapter';
import { ContinentModel } from 'src/models';

const continentAdapter: AdapterFunc<GQL.ContinentDbModel, ContinentModel> = (input) => ({
  id: input.id,
  name: input.name!,
  createdAt: input.createdAt,
  updatedAt: input.updatedAt,
});

export default continentAdapter;
